<form class="edit-modal kw-dialog" (ngSubmit)="submit()" #packageTypeInputForm="ngForm">

  <div class="modal-header">
    <div>
      <h2 class="modal-title">{{this.packageType.id ? 'Update' : 'New'}} {{"Package" | tenantWords}} Type</h2>
      <div class="modal-subtitle">{{this.packageType.id ? this.packageType.name : 'Fields marked * are required'}}</div>
    </div>
    <button mat-icon-button class="close-btn" type="button" aria-label="Close" (click)="cancel()">
      <fa-icon [icon]="faXmark"></fa-icon>
    </button>
  </div>

  <div class="modal-body" [nbSpinner]="this.isLoading">
    <section class="form-section">
      <div class="section-head">
        <fa-icon [icon]="faBoxOpen" class="section-icon"></fa-icon>
        <h3>{{"Package" | tenantWords}} Type</h3>
        <div class="section-actions">
          <mat-slide-toggle color="primary" name="isActive" [(ngModel)]="this.packageType.isActive">Active</mat-slide-toggle>
        </div>
      </div>
      <div class="section-grid">
        <mat-form-field appearance="outline">
          <mat-label>Name</mat-label>
          <input matInput name="name" [(ngModel)]="this.packageType.name" required>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Unit of Measure</mat-label>
          <input matInput name="unitOfMeasure" [(ngModel)]="this.packageType.unitOfMeasure" placeholder="e.g. Box, Bale, Bin">
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-row">
          <mat-label>Description</mat-label>
          <input matInput name="description" [(ngModel)]="this.packageType.description">
        </mat-form-field>
      </div>
    </section>

    <section class="form-section">
      <div class="section-head">
        <fa-icon [icon]="faRulerCombined" class="section-icon"></fa-icon>
        <h3>Weight &amp; Dimensions</h3>
      </div>
      <div class="section-grid cols-3">
        <mat-form-field appearance="outline">
          <mat-label>{{"Package" | tenantWords}} Weight</mat-label>
          <input matInput type="number" name="packageWeight" [(ngModel)]="this.packageType.packageWeight">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Weight UOM</mat-label>
          <input matInput name="weightUnitOfMeasure" [(ngModel)]="this.packageType.weightUnitOfMeasure" placeholder="lb">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Quantity Per Pallet</mat-label>
          <input matInput type="number" name="quantityPerPallet" [(ngModel)]="this.packageType.quantityPerPallet">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Height</mat-label>
          <input matInput type="number" name="height" [(ngModel)]="this.packageType.height">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Width</mat-label>
          <input matInput type="number" name="width" [(ngModel)]="this.packageType.width">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Length</mat-label>
          <input matInput type="number" name="length" [(ngModel)]="this.packageType.length">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Dimension UOM</mat-label>
          <input matInput name="dimensionUnitOfMeasure" [(ngModel)]="this.packageType.dimensionUnitOfMeasure" placeholder="in">
        </mat-form-field>
      </div>
    </section>

    <section class="form-section">
      <div class="section-head">
        <fa-icon [icon]="faCubes" class="section-icon"></fa-icon>
        <h3>Components</h3>
        <div class="section-actions">
          <mat-slide-toggle color="primary" name="hasComponents" [(ngModel)]="this.packageType.hasComponents">Has components</mat-slide-toggle>
        </div>
      </div>
      <p class="section-hint" *ngIf="!this.packageType.hasComponents">
        Turn on when this {{"Package" | tenantWords}} holds smaller units, e.g. a case of 4 × 10 lb bags.
      </p>
      <div class="section-grid cols-3" *ngIf="this.packageType.hasComponents">
        <mat-form-field appearance="outline">
          <mat-label>Component Name</mat-label>
          <input matInput name="componentName" [(ngModel)]="this.packageType.componentName">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Quantity Per {{"Package" | tenantWords}}</mat-label>
          <input matInput type="number" name="componentQuantityPerPackage" [(ngModel)]="this.packageType.componentQuantityPerPackage">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Component UOM</mat-label>
          <input matInput name="componentUnitOfMeasure" [(ngModel)]="this.packageType.componentUnitOfMeasure">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Component Weight</mat-label>
          <input matInput type="number" name="componentWeight" [(ngModel)]="this.packageType.componentWeight">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Weight UOM</mat-label>
          <input matInput name="componentWeightUnitOfMeasure" [(ngModel)]="this.packageType.componentWeightUnitOfMeasure">
        </mat-form-field>
      </div>
    </section>
  </div>

  <div class="modal-footer">
    <button *ngIf="this.packageType.id" mat-stroked-button class="danger-btn" type="button" (click)="deletePackageType()">
      <fa-icon [icon]="faTrash" class="me-2"></fa-icon>Delete
    </button>
    <span class="footer-spacer"></span>
    <button mat-stroked-button type="button" (click)="cancel()">Cancel</button>
    <button mat-raised-button color="primary" type="submit" [disabled]="packageTypeInputForm.invalid || this.isLoading">
      <fa-icon [icon]="faCheck" class="me-2"></fa-icon>Save
    </button>
  </div>

</form>
